import { Field, LinkField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useContext } from 'react';
import { contextType, HeaderContext } from './Header';
import Link from 'components/helpers/Link/Link';
import classNames from 'classnames/bind';

import styles from './Header.module.scss';

const cx = classNames.bind(styles);

type HomeLinkProps = {
  link: LinkField;
  linkText: Field<string>;
};

const HomeLink = (props: HomeLinkProps): React.JSX.Element | null => {
  const { isMobile, openMenu, currentLang, resetMobileMenu, datasourceLanguage } = useContext(
    HeaderContext
  ) as contextType;
  const { sitecoreContext } = useSitecoreContext();
  const { pageEditing } = sitecoreContext;

  if (!pageEditing && (!props || (props.link?.value?.href == '' && props.linkText?.value == ''))) {
    return null;
  }

  return (
    <li
      className={cx(
        { 'header__primary-nav-menu-item': isMobile },
        { 'header__primary-nav-menu-item--tertiary': isMobile }
      )}
    >
      <Link
        field={props.link}
        lang={datasourceLanguage ?? currentLang}
        tabIndex={isMobile && !openMenu ? -1 : 0}
        showLinkTextWithChildrenPresent={false}
        onClick={() => {
          resetMobileMenu();
        }}
      >
        <Text field={props.linkText} encode={pageEditing} />
      </Link>
    </li>
  );
};

export default HomeLink;
